import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  MdOutlineDashboard,
  MdDashboard,
  MdGroup,
  MdOutlineGroup,
  MdLeaderboard,
  MdOutlineLeaderboard,
  MdMenu,
  MdClose,
  MdAddTask,
} from "react-icons/md";
import { FaBuysellads } from "react-icons/fa";
import { BiMoneyWithdraw } from "react-icons/bi";
import { TfiCreditCard } from "react-icons/tfi";

const Navbar1 = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);
  const location = useLocation();
  const [onSelect, setOnSelect] = useState([]);
  const closeTimeoutRef = useRef(null);

  const handleMouseEnter = () => {
    if (closeTimeoutRef.current) clearTimeout(closeTimeoutRef.current);
    setIsOpen(true);
  };
  const handleMouseLeave = () => {
    closeTimeoutRef.current = setTimeout(() => {
      setIsOpen(false);
    }, 200);
  };

  const toggleMobileNav = () => setIsMobileNavOpen(!isMobileNavOpen);

  useEffect(() => {
    const pathArray = location.pathname.split("/");
    setOnSelect(pathArray[1] === "" ? ["dashboard"] : pathArray);
    setIsMobileNavOpen(false);
  }, [location.pathname]);

  const getSelectedIcon = (item) => onSelect.includes(item);

  const getSelectedClass = (item) =>
    onSelect.includes(item)
      ? "bg-main-blue bg-opacity-10 border-r-2 border-main-blue text-main-blue"
      : "text-main-subfont hover:bg-main-blue/10";

  const renderMenuItems = (isMobile = false) => {
    const menuItems = [
      {
        to: "/",
        icon: getSelectedIcon("dashboard") ? (
          <MdDashboard size={20} />
        ) : (
          <MdOutlineDashboard size={20} />
        ),
        label: "Dashboard",
        route: "dashboard",
      },
      {
        to: "/manage/user/all/data",
        icon: getSelectedIcon("user") ? (
          <MdGroup size={20} />
        ) : (
          <MdOutlineGroup size={20} />
        ),
        label: "User Manager",
        route: "user",
      },
      {
        to: "/manage/withdraw",
        icon: <BiMoneyWithdraw size={20} />,
        label: "Withdraw",
        route: "withdraw",
      },
      {
        to: "/manage/leaderboard",
        icon: getSelectedIcon("leaderboard") ? (
          <MdLeaderboard size={20} />
        ) : (
          <MdOutlineLeaderboard size={20} />
        ),
        label: "Leader Board",
        route: "leaderboard",
      },
      {
        to: "/manage/ads/nativeAds/add",
        icon: <FaBuysellads size={20} />,
        label: "Ads Manager",
        route: "ads",
      },
      {
        to: "/manage/cashtask",
        icon: <MdAddTask size={20} />,
        label: "Task",
        route: "cashtask",
      },
      {
        to: "/manage/withdrawcard",
        icon: <TfiCreditCard size={20} />,
        label: "Withdraw Card",
        route: "withdrawcard",
      },
    ];

    return menuItems.map((item) => (
      <li
        key={item.route}
        className={`${getSelectedClass(item.route)} ${
          isMobile ? "w-full px-4 border-b bg-main-blue/10" : "px-2 rounded"
        }`}
      >
        <Link
          to={item.to}
          className={`group flex items-center w-full gap-4 px-2 py-2 rounded transition-all duration-300
            ${!isOpen ? "justify-center" : "justify-start"}
          `}
        >
          {/* ICON PERFECT CENTER BOX */}
          <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-main-bg text-xl transition-all duration-300 group-hover:bg-main-blue group-hover:text-white">
            {item.icon}
          </div>

          {/* DESKTOP TEXT FADE SMOOTH */}
          {(isOpen || isMobile) && (
            <span
              className={`font-medium whitespace-nowrap transition-opacity duration-300 delay-200
              ${isMobile ? "ml-2 flex-1" : "opacity-100 visible"}
              ${!isOpen && !isMobile ? "opacity-0 invisible" : ""}`}
            >
              {item.label}
            </span>
          )}
        </Link>
      </li>
    ));
  };

  return (
    <>
      {/* DESKTOP SIDEBAR */}
      <div
        className={`hidden md:block fixed top-0 z-50 left-0 h-screen
        transition-[width] duration-500 ease-in-out
        ${isOpen ? "w-60" : "w-20"}
        mt-20 bg-main-white border-r border-main-border shadow-xl`}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        style={{ overflow: "hidden" }}
      >
        <nav className="h-full px-2 py-4 flex flex-col">
          <ul className="space-y-1 flex-1">{renderMenuItems()}</ul>
        </nav>
      </div>

      {/* MOBILE NAV - UNSAID (NO CHANGE) */}
      <div className="md:hidden fixed top-0 left-0 w-full z-[100]">
        <button
          onClick={toggleMobileNav}
          className="absolute top-3 left-3 bg-main-blue text-white p-2 rounded-lg shadow-md"
        >
          {isMobileNavOpen ? <MdClose size={26} /> : <MdMenu size={26} />}
        </button>

        <div
          className={`fixed inset-0 bg-black bg-opacity-40 backdrop-blur-sm transition-opacity duration-300 ${
            isMobileNavOpen ? "opacity-100 visible" : "opacity-0 invisible"
          }`}
          onClick={toggleMobileNav}
        />

        <div
          className={`fixed top-0 left-0 h-full w-72 bg-white shadow-2xl transform transition-transform duration-500 z-[110] ${
            isMobileNavOpen ? "translate-x-0" : "-translate-x-full"
          }`}
        >
          <div className="flex items-center justify-between p-4 bg-main-blue text-white">
            <h2 className="text-lg font-semibold">Box Dollars</h2>
            <button onClick={toggleMobileNav}>
              <MdClose size={26} />
            </button>
          </div>

          <div className="flex flex-col items-center py-4 border-b">
            <div className="w-14 h-14 bg-main-blue/20 rounded-full flex items-center justify-center text-main-blue text-xl font-bold">
              A
            </div>
            <p className="font-medium mt-2 text-main-font">Admin Panel</p>
          </div>

          <ul className="py-1 space-y-1">{renderMenuItems(true)}</ul>
        </div>
      </div>
    </>
  );
};

export default Navbar1;
